/* eslint-disable import/no-unresolved */
import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { InputIconWrapper } from 'components';
import { theme, toRem } from 'design';
import Input from '../Input/Input';

const StyledInput = styled(Input)`
  ${(props) =>
    props.size === 'small' &&
    css`
      height: ${toRem(33)};
    `}
`;

export default class ReactDayPickerInput extends Component {
  focus() {
    this.props.innerRef.current.focus();
  }

  render() {
    return (
      <InputIconWrapper icon="Calendar" iconFill={theme.color.neutral[900]} iconPosition="right" onIconClick={() => this.focus()} type="button">
        <StyledInput data-cy="day-picker-input" ref={this.props.innerRef} {...this.props} />
      </InputIconWrapper>
    );
  }
}
